'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Footer = function Footer(props) {
  var links = props.links.map(function (link) {
    return _react2.default.createElement('li', {
      className: 'footer__list-item',
      key: 'footer-link-' + _shortid2.default.generate()
    }, _react2.default.createElement('a', {
      className: 'footer__link',
      href: link.url,
      onClick: link.onClick
    }, link.title));
  });
  var copyright = props.copyright.split(/\n/).map(function (line) {
    return _react2.default.createElement('p', {
      className: 'footer__text',
      key: 'copyright-line-' + _shortid2.default.generate(),
      dangerouslySetInnerHTML: {
        __html: line
      } // eslint-disable-line
    });
  });
  var logo = props.logo ? props.logo : null;
  return _react2.default.createElement('footer', {
    className: 'footer ' + props.className
  }, logo, _react2.default.createElement('ul', {
    className: 'footer__list'
  }, links), copyright);
};
Footer.defaultProps = {
  className: '',
  copyright: 'DR PEPPER is a registered trademark of Dr Pepper/Seven Up, Inc.\n    &copy;2018 Dr Pepper/Seven Up, Inc.\n  ',
  links: [{
    title: 'Privacy Policy',
    url: '/'
  }, {
    title: 'Terms of Use',
    url: '/'
  }, {
    title: 'Accessibility',
    url: '/'
  }, {
    title: 'Contact Us',
    url: '/'
  }, {
    title: 'Careers',
    url: '/'
  }, {
    title: 'Let\'s Play',
    url: '/'
  }, {
    title: 'Corporate Information',
    url: '/'
  }, {
    title: 'FAQ',
    url: '/'
  }],
  logo: null
};
Footer.propTypes = {
  className: _propTypes2.default.string,
  copyright: _propTypes2.default.string,
  logo: _propTypes2.default.node,
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  }))
};
exports.default = Footer;